module.exports = __webpack_public_path__ + "4.3.2/img/bg7.64b60bf9.png";